import {useQueryClient} from '@tanstack/react-query'
import {useCallback} from 'react'
import {createQuery} from 'react-query-kit'

import {apiGetCustomTemplates} from '../api/memex/api-get-custom-templates'
import type {GetCustomTemplatesResponse} from '../api/memex/contracts'

export const useOrganizationTemplates = createQuery<GetCustomTemplatesResponse, void>({
  queryKey: ['org-templates'],
  fetcher: () => apiGetCustomTemplates(),
})

export const usePrefetchOrgTemplates = () => {
  const client = useQueryClient()
  return useCallback(() => client.prefetchQuery(useOrganizationTemplates.getFetchOptions()), [client])
}
